<template>
	<div class="container-wrapper">
<go-back v-if="!$store.state.isMobile" v-model="form" url="/admin/organization-approval-list" label="Back" :backToList="true"></go-back>
<b-container class="add-new-primary-organization-container" v-if="form != null && loaded">
<b-form @submit="onSubmit" @reset="onReset" v-if="form.isApproved.value == null">
	<h1 class="page-title inner-page">Organization Request</h1>
	<b-row>
		<b-col>
			<b-form-group label="Organization Name"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-form-input placeholder="" v-model="form.name.value"
				:state="form.name.status"
				@input="form.name.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row>
		<b-col lg="6">
			<b-form-group label="Domain For User Accounts"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
				<ul>
			<li>The user domain will be used as part of the login for users of your organization.</li>
			<li>The login name of each user will be in the form of <strong><em>user</em></strong><strong>@domain</strong>.</li>
			<li>All sub-organizations (groups, branches, etc.) will share the same user domain.</li>
			<li>The domain does not need to be the same as your email address domain.</li>
			<li>Include the '@' symbol as part of your domain</li>
			</ul>
			<b-input-group prepend="user">
				<b-form-input placeholder="@mycompany" v-model="form.domain.value"></b-form-input>
			</b-input-group>
			</b-form-group>
		</b-col>
	</b-row>

	<b-row>
	<b-col lg="6">
	<b-form-group label="First Name"
		:state="form.firstName.status"
		:invalid-feedback="form.firstName.invalidMessage"
	>
	<b-form-input placeholder="First Name" v-model="form.firstName.value"
		:state="form.firstName.status"
		@input="form.firstName.resetStatus()"
	></b-form-input>
	</b-form-group>
	<b-form-group label="Last Name"
		:state="form.lastName.status"
		:invalid-feedback="form.lastName.invalidMessage"
	>
	<b-form-input placeholder="Last Name" v-model="form.lastName.value"
		:state="form.lastName.status"
		@input="form.lastName.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Title"
		:state="form.title.status"
		:invalid-feedback="form.title.invalidMessage"
	>
	<b-form-input placeholder="Title" v-model="form.title.value"
		:state="form.title.status"
		@input="form.title.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Email Address"
		:state="form.email.status"
		:invalid-feedback="form.email.invalidMessage"
	>
	<b-form-input type="email" placeholder="Email Address" v-model="form.email.value"
		:state="form.email.status"
		@input="form.email.resetStatus()"
	></b-form-input>
	</b-form-group>

	<b-form-group label="Primary Phone"
		:state="form.phone.status"
		:invalid-feedback="form.phone.invalidMessage"
	>
	<b-input id="editOrgRequestUserPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="form.phone.value" placeholder="1-###-###-####"/>
	</b-form-group>


	<b-form-group label="Alternate Phone"
		:state="form.altPhone.status"
		:invalid-feedback="form.altPhone.invalidMessage"
	>
	<b-input id="editOrgRequestUserAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="form.altPhone.value" placeholder="1-###-###-####"/>
	</b-form-group>

	</b-col>
</b-row>
	<b-row>
		<b-col lg="6">
			<b-form-group label="Internal Comments (will also be emailed to registrant if rejecting)"
				:state="form.comments.status"
				:invalid-feedback="form.comments.invalidMessage"
			>
			<wysiwyg v-model="form.comments.value"></wysiwyg>
			</b-form-group>
		</b-col>
	</b-row>

<b-row>
	<b-col>
		<!-- <b-button variant="primary" type="button" @click="onSubmit">Save</b-button> -->

		<b-button variant="primary" type="button" class="create__organization" @click="onApprove">Approve Organization Request</b-button>
		<b-button variant="secondary" type="button" class="create__organization ml-3" @click="onReject">Reject</b-button>

	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>
</b-form>
<div v-if="form.isApproved.value != null">
			<h1 class="page-title inner-page">Organization Request</h1>
			<b-row>
				<b-col>
					<b-form-group label="Organization Name"
						:state="form.name.status"
						:invalid-feedback="form.name.invalidMessage"
					>
					<div v-html="form.name.value"></div>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col lg="6">
					<b-form-group label="Domain For User Accounts"
						:state="form.name.status"
						:invalid-feedback="form.name.invalidMessage"
					>
					<div v-html="form.domain.value"></div>
					</b-form-group>
				</b-col>
			</b-row>

			<b-row>
			<b-col lg="6">
			<b-form-group label="First Name"
				:state="form.firstName.status"
				:invalid-feedback="form.firstName.invalidMessage"
			>
					<div v-html="form.firstName.value"></div>

			</b-form-group>
			<b-form-group label="Last Name"
				:state="form.lastName.status"
				:invalid-feedback="form.lastName.invalidMessage"
			>
					<div v-html="form.lastName.value"></div>

			</b-form-group>

			<b-form-group label="Title"
				:state="form.title.status"
				:invalid-feedback="form.title.invalidMessage"
			>
					<div v-html="form.title.value"></div>
			</b-form-group>

			<b-form-group label="Email Address"
				:state="form.email.status"
				:invalid-feedback="form.email.invalidMessage"
			>
					<div v-html="form.email.value"></div>

			</b-form-group>

			<b-form-group label="Primary Phone"
				:state="form.phone.status"
				:invalid-feedback="form.phone.invalidMessage"
			>
				<div v-html="form.phone.value"></div>
			</b-form-group>


			<b-form-group label="Alternate Phone"
				:state="form.altPhone.status"
				:invalid-feedback="form.altPhone.invalidMessage"
			>
				<div v-html="form.altPhone.value"></div>
			</b-form-group>

			</b-col>
		</b-row>
			<b-row v-if="form.comments.value">
				<b-col lg="6">
					<b-form-group label="Internal Comments (will also be emailed to registrant if rejecting)"
						:state="form.comments.status"
						:invalid-feedback="form.comments.invalidMessage"
					>
					<div v-html="form.comments.value"></div>
					</b-form-group>
				</b-col>
			</b-row>

			<!-- leaving page -->
			<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
				<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
				<template v-slot:modal-footer="{ ok }">
					<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
					<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
					<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
				</template>
			</b-modal>
</div>


</b-container>
<Spinner v-else />
</div>
</template>


<script>
import OrganizationRequest from '../../../models/OrganizationRequest';
import BootstrapField from '../../../utility/BootstrapField';
import ErrorHandler from '../../../utility/ErrorHandler';
import GoBack from '../../../components/GoBack.vue';
import Spinner from "./../../../components/Spinner.vue";
import Format from '../../../utility/Format';
import Vue from 'vue'

export default {
  name: 'EditOrganizationRequest',
  docTitle: "Organization Request - Lane Closures",

  components: {
	GoBack,
	Spinner,
  },
  props:['id'],
  data() {
	return {
		OrganizationRequest,
		form: null,
		organizations: [],
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		show: true,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		passwordStrength:0,
		confirmPasswordStrength:0,
		usernamePrefix:new BootstrapField({
					value: "admin"}),
	}
	},
	mounted() {
		this.LoadData();
		this.$nextTick(() => {
		})
   },
	computed: {
		organizationSuffix: function() {
			if (this.form.domain.value) {
				if (this.form.domain.value) {
					return this.form.domain.value;
				}
			}

			return "@mycompany";
		}
	},
	watch: {
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
	'form.orgAdminUsername.value':function() {
		this.calculateUserName();
	},
	},
  methods: {
  	modalOnCancel() {
  		this.showUnsavedChangesModal = false;
  	},
  	onPhoneFocus:function() {
  		if (this.form.phone.value == null || this.form.phone.value == "") {
  			setTimeout(function(){
  			      document.getElementById('editOrgRequestUserPhone').value = "1-";
  			      document.getElementById('editOrgRequestUserPhone').selectionStart = document.getElementById('editOrgRequestUserPhone').value.length;
  			      document.getElementById('editOrgRequestUserPhone').selectionEnd = document.getElementById('editOrgRequestUserPhone').value.length;
  			    },1);  // call the function after 50ms
  		}
  	},
  	onPhoneBlur:function() {
  		if (this.form.phone.value == "1-" || document.getElementById('editOrgRequestUserPhone').value == "1-") {
  			this.form.phone.value = null;
  			setTimeout(function(){
  			    document.getElementById('editOrgRequestUserPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
  	onAltPhoneFocus:function() {
  		if (this.form.altPhone.value == null || this.form.altPhone.value == "") {
  				// this.form.altPhone.value = "1-";
  			setTimeout(function(){
  			      document.getElementById('editOrgRequestUserAltPhone').value = "1-";
  			      document.getElementById('editOrgRequestUserAltPhone').selectionStart = document.getElementById('editOrgRequestUserAltPhone').value.length;
  			      document.getElementById('editOrgRequestUserAltPhone').selectionEnd = document.getElementById('editOrgRequestUserAltPhone').value.length;
  			    },1);  // call the function after 50ms

  		}
  	},
  	onAltPhoneBlur:function() {
  		if (this.form.altPhone.value == "1-" || document.getElementById('editOrgRequestUserAltPhone').value == "1-") {
  			this.form.altPhone.value = null;
  			setTimeout(function(){
  			    document.getElementById('editOrgRequestUserAltPhone').value = null;
  			},1);  // call the function after 50ms
  		}
  	},
	calculateUserName() {
		if (this.usernamePrefix.value) {
			this.form.orgAdminUsername.value = this.usernamePrefix.value + this.form.domain.value;
		} else {
			this.form.orgAdminUsername.value = null;
		}
	},
	updatePasswordStrength(password) {
		let has_number    = /\d/.test(password);
		let has_lowercase = /[a-z]/.test(password);
		let has_uppercase = /[A-Z]/.test(password);
		let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
		let strength = 0;
		if (has_number) {
			strength++;
		}
		if (has_lowercase) {
			strength++;
		}
		if (has_uppercase) {
			strength++;
		}
		if (has_special) {
			strength++;
		}
		if (password.length < 8) {
			strength = 0;
		}
		this.passwordStrength = strength;
	},
	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

	getLevelClassName(level) {
		return "level-"+level;
	},

	closeNewProjectModal() {
		this.showNewProjectModal = false;
	},
	openNewProjectModal() {
		this.showNewProjectModal = true;
	},
		onSubmit(evt) {
			evt.preventDefault()
			// if (!this.validateFields()) {
			// 	return false;
			// }
			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.form);
			});

		},

		onApprove(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}
			this.form.isApproved.value = 1;
			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.form);
			});

		},
		onReject(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}
			let that = this;
			this.form.isApproved.value = 0;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.Save(that.form);
			});

		},



		onReset(evt) {
			evt.preventDefault()
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},
		Save(t) {
			if (t instanceof OrganizationRequest) {
				let go = true;
				if (go) {
				Vue.prototype.$http({
					method: 'put',
					url: `${this.$store.state.apiUrl}/organization-request/${t.id}/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					// Handle Success
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					if (error) {
						this.saveState = 'fail';
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.form.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						} else {
							// ErrorHandler.RedirectToLogin();
						}
						this.onSubmitPromiseDeferred.reject();
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SaveSuccess() {
			this.$router.push('/admin/organization-approval-list');
		},

		validateFields() {
			let valid = this.form.validate();
			if (valid ) {
				return true;
			}
			return false;
		},


			LoadData(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				this.form = new OrganizationRequest();
				this.form.parentId = null;
					this.$store.dispatch('organizationList/load', this.$store.getters['organizationList/getParams'])
						.then(() => {
								this.organizations = [];
								this.organizations.push({id:-1,name:"This is the Primary Organization", parentId:null});
								let records = this.$store.getters['organizationList/getRecords'];
								if ( records ) {
									records.forEach( item => {
										this.organizations.push(item);
									})
								}
							})
						.catch( error => console.log('error', error) ); // eslint-disable-line

				if (id && Format.TryParseInt(id) > 0) {
					this.GetData(id);
				}
				else {
					if (this.data) {
						this.form = new OrganizationRequest(this.data);
						this.form.saveChanges();
					} else {
						this.form = new OrganizationRequest();
						this.form.parentId = -null;
					}
					this.loaded = true;
				}
			},

			GetData(id) {
				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/organization-request/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.form = new OrganizationRequest(response.data);
						// this.$store.commit('formId', response.data.Id);
						this.loaded = true;
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}

			},


	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.form.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>